import React from 'react';
import { Link } from '@hub/link';
import TradingHoursLine from '../trading-hours-line';
import { SEE_MORE_OPENING_HOURS_TEXT } from '../../constants';
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel } from '@hub/accordion';
import { Text } from '@hub/text';
import { Box } from '@hub/box';
import { HoursMediumIcon } from '@hub/icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function calculateNumberOfHoursDisplayed(parsedHours) {
  const MAX_DISPLAYED_DAYS = 7;
  const numberOfDaysDisplayed = Math.min(MAX_DISPLAYED_DAYS, parsedHours.length);
  return parsedHours.slice(0, numberOfDaysDisplayed);
}
const UtilityBoxOpeningHours = _ref => {
  let {
    openingHours,
    centreSlug,
    unlinkedHours,
    seeMoreOpeningHoursUrl
  } = _ref;
  if (openingHours.length === 0) {
    return null;
  }
  const displayedHours = calculateNumberOfHoursDisplayed(openingHours);
  const headerHours = displayedHours[0];
  const contentHours = displayedHours.slice(1);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Accordion, {
      allowToggle: true,
      "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Accordion",
      children: /*#__PURE__*/_jsxs(AccordionItem, {
        "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Accordion_AccordionItem",
        children: [/*#__PURE__*/_jsxs(AccordionButton, {
          sx: {
            paddingInlineStart: 0,
            display: 'flex',
            textAlign: 'left',
            marginTop: 'spacing-md',
            alignItems: 'center',
            width: 'unset'
          },
          "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_AccordionItem_AccordionButton",
          children: [/*#__PURE__*/_jsx(HoursMediumIcon, {
            boxSize: "size-icon-md",
            "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_AccordionButton_HoursMediumIcon"
          }), /*#__PURE__*/_jsx(Box, {
            sx: {
              flex: 1,
              maxWidth: 'size-20',
              marginLeft: 'spacing-md'
            },
            "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_AccordionButton_Box",
            children: /*#__PURE__*/_jsx(TradingHoursLine, {
              openHourDay: headerHours,
              "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Box_TradingHoursLine"
            })
          }), /*#__PURE__*/_jsx(Box, {
            sx: {
              marginLeft: 'spacing-sm'
            },
            "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_AccordionButton_Box",
            children: /*#__PURE__*/_jsx(AccordionIcon, {
              "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Box_AccordionIcon"
            })
          })]
        }), /*#__PURE__*/_jsx(AccordionPanel, {
          sx: {
            paddingLeft: 'spacing-2xl'
          },
          "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_AccordionItem_AccordionPanel",
          children: /*#__PURE__*/_jsxs(Box, {
            "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_AccordionPanel_Box",
            children: [/*#__PURE__*/_jsx(Box, {
              "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Box_Box_10",
              children: contentHours.map(day => /*#__PURE__*/_jsx(Box, {
                sx: {
                  marginTop: 'spacing-md'
                },
                "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Box_11",
                children: /*#__PURE__*/_jsx(TradingHoursLine, {
                  openHourDay: day,
                  "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Box_TradingHoursLine"
                })
              }, day.day))
            }), seeMoreOpeningHoursUrl && /*#__PURE__*/_jsx(Box, {
              sx: {
                marginTop: 'spacing-sm'
              },
              "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Box",
              children: /*#__PURE__*/_jsx(Link, {
                href: '',
                hasUnderline: true,
                "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Box_Link",
                children: SEE_MORE_OPENING_HOURS_TEXT
              })
            })]
          })
        })]
      })
    }), unlinkedHours && /*#__PURE__*/_jsxs(Box, {
      sx: {
        marginLeft: 'spacing-2xl',
        marginTop: 'spacing-sm'
      },
      "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Box",
      children: [/*#__PURE__*/_jsx(Text, {
        "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Box_Text",
        children: "Hours may differ from Centre hours"
      }), /*#__PURE__*/_jsx(Link, {
        hasUnderline: true,
        href: "/".concat(centreSlug, "/opening-hours"),
        "data-id": "utility-box-opening-hours_index_UtilityBoxOpeningHours_Box_Link",
        children: "View Centre Hours"
      })]
    })]
  });
};
UtilityBoxOpeningHours.defaultProps = {
  openingHours: [] // eslint-disable-line react/default-props-match-prop-types
};

export default UtilityBoxOpeningHours;